import { useMemo, useState } from "react";
import {
  legacyPushResultOfficeGroups,
  legacyPushResultOffices,
  legacySmsAutoSettings,
} from "../../mock/legacySms";
import "./LegacySmsAutoSetting.css";
import "./LegacySmsAutoSettingTune.css";

const headers = [
  "No",
  "지점",
  "활성여부",
  "수신대상",
  "수신자",
  "조건(일자)",
  "발송번호",
  "조건1",
  "조건2",
  "조건3",
  "광고",
  "내용",
];
const columnWidths = [
  124.5625, 147.03125, 237.359375, 237.359375, 192.21875, 278.125, 237.359375,
  171.53125, 178.953125, 180.375, 147.03125, 147.09375,
];

export function LegacySmsAutoSetting() {
  const [group, setGroup] = useState("Mock 그룹 01");
  const [office, setOffice] = useState<string>(legacyPushResultOffices[0]);
  const [states, setStates] = useState(["전체", "활성", "비활성"]);
  const [searched, setSearched] = useState(false);
  const [expand, setExpand] = useState(false);
  const [notice, setNotice] = useState<string | null>(null);
  const records = useMemo(
    () =>
      legacySmsAutoSettings.filter(
        (item) =>
          states.includes("전체") ||
          states.includes(item.enabled ? "활성" : "비활성"),
      ),
    [states],
  );
  const toggle = (value: string) =>
    setStates((current) =>
      value === "전체"
        ? current.length === 3
          ? []
          : ["전체", "활성", "비활성"]
        : current.includes(value)
          ? current.filter((item) => item !== value && item !== "전체")
          : [...current.filter((item) => item !== "전체"), value],
    );
  const search = (event: React.FormEvent) => {
    event.preventDefault();
    setSearched(true);
    const params = new URLSearchParams({
      is_search: "1",
      group_id: group === "Mock 그룹 01" ? "mock-group-01" : "mock-group-02",
      office_id:
        office === legacyPushResultOffices[0]
          ? "mock-office-01"
          : "mock-office-02",
      is_cancel: states.join(","),
    });
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${params}`,
    );
  };
  const goSchedule = () => {
    window.history.pushState({}, "", "/v2/sms_auto_send_schedule/list/");
    window.dispatchEvent(new PopStateEvent("popstate"));
  };
  const openPopup = (path: string) => {
    window.open(path, "_blank", "popup=yes,width=1100,height=800");
  };
  return (
    <div className="legacy-m06">
      <h2 className="g_title">문자 자동 발송 설정 목록</h2>
      <section className="g_filter_wrap l_filter_schedule_wrap">
        <div className="g_row">
          <div className="g_input_wrap l_title_wrap">
            <label className="g_label title center">1차 발송</label>
            <span className="g_text setting_info">Mock 1차 발송 시각</span>
          </div>
        </div>
        <div className="g_row">
          <div className="g_input_wrap l_title_wrap">
            <label className="g_label title center">2차 발송</label>
            <span className="g_text setting_info">Mock 2차 발송 시각</span>
          </div>
        </div>
        <div className="g_row">
          <div className="g_input_wrap l_title_wrap">
            <label className="g_label no_style" />
            <span className="g_text comment">
              * 발송시각 설정은{" "}
              <button
                className="g2_btn link l_btn_go_pmsg_auto_send_schedule_list"
                type="button"
                onClick={goSchedule}
              >
                문자 자동 발송 내역
              </button>
              에서 설정할 수 있습니다.
            </span>
          </div>
        </div>
      </section>
      <section className="g_filter_wrap l_filter_search_wrap">
        <form id="l_form_search" onSubmit={search}>
          <div className="g_row">
            <div className="g_input_wrap required">
              <label className="g_label title center">그룹</label>
              <M06Chooser
                id="l_inp_where_group"
                value={group}
                values={["Mock 그룹 01", "Mock 그룹 02"]}
                onChange={setGroup}
              />
            </div>
          </div>
          <div className="g_row">
            <div className="g_input_wrap required">
              <label className="g_label title center">지점</label>
              <M06GroupedChooser
                id="l_inp_where_office"
                value={office}
                onChange={setOffice}
              />
            </div>
          </div>
          <div className="g_row">
            <div className="g_input_wrap">
              <label className="g_label title center">활성여부</label>
              {["전체", "활성", "비활성"].map((item) => (
                <label className="g_input checkbox_wrap" key={item}>
                  <input
                    className={`g_input checkbox l_inp_where_chk_is_cancel ${item === "전체" ? "g_checked_toggle_all" : "g_checked_toggle"}`}
                    type="checkbox"
                    checked={states.includes(item)}
                    onChange={() => toggle(item)}
                  />
                  {item}
                </label>
              ))}
            </div>
          </div>
          <div className="g_row">
            <div className="g_input_wrap">
              <label className="g_label no_style" />
              <button className="g2_btn g_btn_submit search" type="submit">
                검색
              </button>
            </div>
          </div>
        </form>
      </section>
      <section className="l_result_section">
        <div className="g_row">
          <button
            className="g2_btn add l_btn_add"
            type="button"
            onClick={() =>
              openPopup(
                "/v2/sms_auto_send_setting/add/?group_id=mock-group-01&office_id=mock-office-01",
              )
            }
          >
            문자 자동발송 조건 추가
          </button>
          <label className="g_input checkbox_wrap">
            <input
              type="checkbox"
              className="g_input checkbox"
              id="l_chk_expand_content"
              checked={expand}
              onChange={(event) => setExpand(event.target.checked)}
            />
            내용 펼치기
          </label>
        </div>
        <section className="g_card g_result_table_wrap">
          <div className="g_list_wrap g_list_thead_sticky g_body_sticky">
            <table
              className={`g_list${expand ? " l_expanded" : ""}`}
              id="l_search_result_table"
            >
              <colgroup>
                {columnWidths.map((width, index) => (
                  <col key={index} style={{ width }} />
                ))}
              </colgroup>
              <thead>
                <tr>
                  {headers.map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {searched ? (
                  records.map((row, index) => (
                    <tr
                      className="l_click_modify"
                      key={row.id}
                      onClick={() =>
                        openPopup(
                          `/v2/sms_auto_send_setting/update/?group_id=mock-group-01&office_id=mock-office-01&pmsg_auto_send_cfg_pk=${row.id}`,
                        )
                      }
                    >
                      <td>{index + 1}</td>
                      <td>{row.office}</td>
                      <td>{row.enabled ? "활성" : "비활성"}</td>
                      <td>{row.target}</td>
                      <td>{row.recipient}</td>
                      <td>{row.dateCondition}</td>
                      <td>{row.calling}</td>
                      <td>{row.condition1}</td>
                      <td>{row.condition2}</td>
                      <td>{row.condition3}</td>
                      <td>{row.advertisement ? "광고" : "-"}</td>
                      <td className="l_td_pmsg_contents">{row.content}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={12}>데이타를 검색 하세요...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      </section>
      {notice && (
        <div className="m06-notice">
          {notice}
          <button type="button" onClick={() => setNotice(null)}>
            ×
          </button>
        </div>
      )}
    </div>
  );
}

function M06Chooser({
  id,
  value,
  values,
  onChange,
}: {
  id: string;
  value: string;
  values: string[];
  onChange: (value: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState("");
  const shown = values.filter((item) => item.includes(filter));
  return (
    <>
      <select
        id={id}
        className="g_input chosen-select"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        {values.map((item) => (
          <option key={item}>{item}</option>
        ))}
      </select>
      <div
        id={`${id}_chosen`}
        className={`chosen-container chosen-container-single${open ? " chosen-with-drop" : ""}`}
      >
        <button
          type="button"
          className="chosen-single"
          onClick={() => setOpen((v) => !v)}
        >
          <span>{value}</span>
        </button>
        <div className="chosen-drop">
          <div className="chosen-search">
            <input
              className="chosen-search-input"
              value={filter}
              onChange={(event) => setFilter(event.target.value)}
            />
          </div>
          <ul className="chosen-results">
            {shown.map((item) => (
              <li
                className="active-result"
                key={item}
                onClick={() => {
                  onChange(item);
                  setOpen(false);
                }}
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
function M06GroupedChooser({
  id,
  value,
  onChange,
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <M06Chooser
      id={id}
      value={value}
      values={legacyPushResultOfficeGroups.flatMap((group) => group.options)}
      onChange={onChange}
    />
  );
}
